// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RecurringRuleModal_form__2dyv4 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 0 16px;\n  gap: 0 16px; }\n  .RecurringRuleModal_form__2dyv4 .ant-form-item {\n    margin-bottom: 16px; }\n\n.RecurringRuleModal_fullWidthItem__20Nd- {\n  grid-column: span 2; }\n\n.RecurringRuleModal_checkboxRow__3RK8v {\n  display: flex;\n  align-items: center;\n  grid-gap: 8px;\n  gap: 8px; }\n", ""]);
// Exports
exports.locals = {
	"form": "RecurringRuleModal_form__2dyv4",
	"fullWidthItem": "RecurringRuleModal_fullWidthItem__20Nd-",
	"checkboxRow": "RecurringRuleModal_checkboxRow__3RK8v"
};
module.exports = exports;
